import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
    {
        q: "How does MechXpress match me with a mechanic?",
        a: "We match you with verified local mechanics based on your location and car issue details.",
    },
    {
        q: "Can I see prices before I book?",
        a: "Yes — all pricing is shown upfront before you confirm. No hidden fees, no surprises.",
    },
    {
        q: "What happens if I'm not satisfied with my service?",
        a: "Contact our support team and we'll help resolve any concerns quickly.",
    },
    {
        q: "Can I talk to the mechanic before they arrive?",
        a: "Yes — once matched, you can message your mechanic directly inside the app. Discuss your issue, share photos of your car, negotiate pricing for custom jobs, and confirm arrival time. All communication stays in the app — no personal numbers shared.",
    },
    {
        q: "Is MechXpress available in my area?",
        a: "MechXpress is currently launching in the DMV area — Washington DC, Maryland, and Virginia. Sign up for the waitlist and we'll notify you the moment we go live near you.",
    },
    {
        q: "How are mechanics vetted on MechXpress?",
        a: "Every mechanic on MechXpress is independently verified and must maintain a minimum 3-star rating to stay on the platform. Mechanics with repeated negative reviews are suspended automatically — so you only ever see quality service providers.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-24 sm:py-32 bg-white"
        >
            <div className="max-w-4xl mx-auto px-6 lg:px-8">
                <Reveal>
                    <div className="mb-12 sm:mb-16 text-center">
                        <div className="text-xs uppercase tracking-[0.2em] text-[#10B981] font-bold mb-4">
                            FAQ
                        </div>
                        <h2 className="text-4xl sm:text-5xl font-black tracking-tight text-[#070F1D]">
                            Everything you want to know.
                        </h2>
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <Accordion
                        type="single"
                        collapsible
                        className="divide-y divide-slate-200 border border-slate-200 rounded-2xl bg-white shadow-[0_8px_32px_-12px_rgba(7,15,29,0.08)]"
                        data-testid="faq-accordion"
                    >
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="px-6 sm:px-8 border-b-0"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-[#070F1D] hover:text-[#10B981] hover:no-underline py-6">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-slate-600 text-base leading-relaxed pb-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
